import React from 'react'
import { EventData } from '../EventPage'
import {
  tuesdayData,
  wednesdayData,
  thursdayData
} from '../../ConsensusEvent/data/scheduleData'

export const event2025Data: EventData = {
  title: 'Annual Sickle Cell Disease Centers & Consensus Conference',
  subtitle: 'July 20 – 25, 2025 • Stoweflake Mountain Resort, Stowe, Vermont',
  description: (
    <>
      <p className="text-[#3C2416] text-base md:text-lg leading-relaxed">
        This 4-day gathering is NASCC&apos;s opportunity to connect clinicians,
        researchers, social-service professionals, and patient advocates around
        the latest advances in sickle-cell disease (SCD) care. After a decade of
        rapid therapeutic progress, the 2025 meeting focuses on getting every
        person living with SCD access to a specialist, sharing best practices,
        and accelerating adoption of new treatments. Most attendees should plan
        to arrive Sunday, July 20; plenary programming begins Monday morning,
        July 21 and concludes Friday, July 25 at 1 p.m. Shuttle service between
        Burlington (BTV) and the resort is provided, and overflow-hotel
        assistance is available via Patricia Brown
        (pbrown@sicklecellcenters.org). New this year are CME-bearing learning
        &quot;pathways&quot; for physicians, APPs, nurses/infusion staff,
        neuro-cognitive specialists, social-workers/care-coordinators, and a
        &quot;How I Treat Adults with SCD&quot; track for new specialists. All
        non-consensus sessions are open to registered attendees, with a
        virtual-attendance option. <br />
        <br /> You can find the registration form{' '}
        <a
          href="https://consensus.sicklecellcenters.org/2025-nascc-annual-meeting--consensus"
          className="text-[#142841] underline hover:no-underline"
        >
          here
        </a>
        .
      </p>
    </>
  ),
  registrationLink:
    'https://consensus.sicklecellcenters.org/2025-nascc-annual-meeting--consensus',
  shuttleSchedule: true,
  sponsors: true,
  schedules: {
    sunday: true,
    monday: true,
    tuesday: tuesdayData,
    wednesday: wednesdayData,
    thursday: thursdayData,
    friday: true
  },
  disclosures: {
    disclosureLink:
      'https://www.francefoundation.com/content/9464-nascc/disclosure_table.pdf',
    cmeLink: 'https://www.francefoundation.com/9464-nascc-vt-cme'
  }
}
